import React, { FunctionComponent, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IDevice } from 'interfaces';
import { Loader } from 'components';
import { formatDateShort, formatTime } from 'services/Utils';
import { LoadState } from 'enums';
import { Overlay, Popover } from 'react-bootstrap';

interface IDevicesItemProps {
    device: IDevice,
    isChecked: boolean,
    className: string,
    onPingDevices: (d: IDevice[]) => void,
    onShowDeviceModal: (d: IDevice) => void,
    onSelectDevice: (d: IDevice) => void,
}

export const DevicesItem: FunctionComponent<IDevicesItemProps> = ({ device, isChecked, className, onPingDevices, onShowDeviceModal, onSelectDevice }) => {

    // info fields
    const serial = "Serial Number:";
    const location = "Location:";
    
    const serialTitle = serial + ' ' + device.serialNumber;
    const locationTitle = location + ' ' + device.location.number
    
    const lastSeenDate = formatDateShort(device.lastSeen);
    const lastSeenTime = formatTime(device.lastSeen);

    // dropdown button and popover
    const dropdownButtonRef = useRef(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    return (
        <li className={className} key={device.id}>
            <div className="devicesItem_checkCol devicesItem_col">
                <div className="devicesItem_checkCircle">
                    <input 
                        name={device.id + ''}
                        type="checkbox"
                        className="devicesItem_check" 
                        onChange={() => onSelectDevice(device)}
                        checked={isChecked}
                    />
                </div>
            </div>
            <Link to={'/devices'} onClick={() => onShowDeviceModal(device)} className="devicesItem_modalLink">
                <div className="devicesItem_iconCol devicesItem_col">
                    <div className="devicesItem_iconCircle">
                        <FontAwesomeIcon icon="hdd" className="devicesItem_icon" />
                    </div>
                </div>
                <div className="devicesItem_makeModelCol devicesItem_col">
                    <div className="devicesItem_manufacturer ellipsis" title={device.manufacturer.name}>
                        {device.manufacturer.name}
                    </div>
                    <div className="devicesItem_model ellipsis" title={device.modelNumber}>
                        {device.modelNumber}
                    </div>
                </div>
                <div className="devicesItem_detailsCol devicesItem_col">
                    <div className="devicesItem_detailsLeft">
                        <div className="ellipsis" title={serialTitle}>
                            {serial}
                        </div>
                        <div className="ellipsis" title={locationTitle}>
                            {location}
                        </div>
                    </div>
                    <div className="devicesItem_detailsRight">
                        <div className="ellipsis" title={serialTitle}>
                            {device.serialNumber}
                        </div>
                        <div className="ellipsis" title={locationTitle}>
                            {device.location.number}
                        </div>
                    </div>
                </div>
                <div className="devicesItem_lastSeenCol devicesItem_col" title={lastSeenDate + ' ' + lastSeenTime}>
                    {lastSeenDate} <br/>
                    {lastSeenTime}
                </div>
            </Link>

            {device.pingStatus != LoadState.Loading && <Link
                to={'/devices'}
                onClick={() => onPingDevices([device])}
                className="devicesItem_editCol"
            >
                <FontAwesomeIcon icon="bell" className="devicesItem_editIcon" />
            </Link>}

            {device.pingStatus == LoadState.Loading && <Link
                to={'/devices'}
                onClick={e => e.preventDefault()}
                className="devicesItem_editCol"
            >
                <Loader />
            </Link>}

            <Link 
                to={'/devices'} 
                onClick={() => setDropdownOpen(!dropdownOpen)}
                ref={dropdownButtonRef}
                className="devicesItem_editCol"
            >
                <FontAwesomeIcon icon="chevron-down" className="devicesItem_editIcon" />
            </Link>

            <Overlay
                target={dropdownButtonRef}
                show={dropdownOpen}
                onHide={() => setDropdownOpen(false)}
                rootClose
                placement="bottom"
            >
                <Popover id="commandOption_popover" className="dropdownPopover">
                    <Popover.Content>
                        <Link to={`/commands?thingID=${device.thingID}`} className="devicesItem_dropdown">
                            Command
                        </Link>
                        <Link to={`/subscribe?thingID=${device.thingID}`} className="devicesItem_dropdown">
                            Subscribe
                        </Link>
                    </Popover.Content>
                </Popover>
            </Overlay>

        </li>
    );
}
